import { licitaciones } from "@/lib/mock-data";
import { mockCompanyProfile } from "./intelligence/company-profile.mock";
import { computeMatch } from "./intelligence/scoring";
import type { OpportunityCard, SmartAlert, WatchlistItem } from "@/types";

export const mockOpportunities: OpportunityCard[] = licitaciones
  .map((lic) => ({
    licitacion: lic,
    scoring: computeMatch(mockCompanyProfile, lic),
  }))
  .sort((a, b) => b.scoring.score - a.scoring.score);

export const mockWatchlist: WatchlistItem[] = [
  {
    id: "w-1",
    kind: "organismo",
    valor: "Hospital Clínico San Borja",
    creadoEn: "2025-11-10",
    activo: true,
    matches: 8,
    matchesHistoricos: 48,
  },
  {
    id: "w-2",
    kind: "categoria",
    valor: "Tecnología y Software",
    creadoEn: "2025-10-22",
    activo: true,
    matches: 34,
    matchesHistoricos: 210,
  },
  {
    id: "w-3",
    kind: "keyword",
    valor: "gestión documental",
    creadoEn: "2025-12-01",
    activo: true,
    matches: 12,
    matchesHistoricos: 96,
  },
  {
    id: "w-4",
    kind: "competidor",
    valor: "Sonda S.A.",
    creadoEn: "2025-09-14",
    activo: false,
    matches: 19,
    matchesHistoricos: 140,
  },
  {
    id: "w-5",
    kind: "region",
    valor: "Metropolitana",
    creadoEn: "2025-08-04",
    activo: true,
    matches: 64,
    matchesHistoricos: 720,
  },
];

export const mockSmartAlerts: SmartAlert[] = mockOpportunities.slice(0, 6).map((o, i) => ({
  id: `alert-${i + 1}`,
  titulo:
    i === 0
      ? "Nueva licitación detectada"
      : i === 1
        ? "Oportunidad con alta probabilidad"
        : "Match relevante en watchlist",
  mensaje: `${o.licitacion.nombre} — ${o.licitacion.organismo}`,
  nivel: o.scoring.score >= 80 ? "urgente" : o.scoring.score >= 60 ? "warning" : "info",
  score: o.scoring.score,
  probabilidad: o.scoring.probabilidad,
  licitacionId: o.licitacion.id,
  recomendacion: o.scoring.recommendation,
  ts: new Date(Date.now() - i * 3600_000).toISOString(),
}));
